<template>
  <div>
    <MainSearcherBlock></MainSearcherBlock>
    <!-- <MainMapSearchBlock></MainMapSearchBlock> -->
  </div>
</template>

<script>
//components
import MainSearcherBlock from './blocks/MainSearcherBlock'
import MainMapSearchBlock from './blocks/MainMapSearchBlock'

//libraries
import moment from "moment"

export default {
  name: "MainHomeContent",
  components: { MainSearcherBlock, MainMapSearchBlock},
  data() {
    return {
      currentDate: moment().format("YY/MM/DD"),
    };
  },
  methods: {
    track () {
      this.$ga.page('/')
    },
    setVisibility( lang_array ) {
      if(this.$store){
        return (lang_array.indexOf(this.$store.getters['lang/getLang']) != -1) ? true:false
      }
    },
    getLang: function (){
      return this.$store.getters['lang/getLang']
    },
    getFullUrl(value){
      function removeAccents(str) {
        let accents = 'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
        let accentsOut = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
        str = str.split('');
        str.forEach((letter, index) => {
          let i = accents.indexOf(letter);
          if (i != -1) {
            str[index] = accentsOut[i];
          }
        })
        return str.join('');
      }

      if(this.$store){
        return '/'+this.$store.getters['lang/getShortLang']+'/' + removeAccents(value).toLowerCase()
      }
    },
    saveMerchant(payload) {
      let self = this;
      self.$store.dispatch("saveMerchant",{ data: {
        title: payload.name,
        short_description: payload.description,
        full_description: payload.description,
        logo_img_path: payload.image_src,
        website: payload.link,
      }}).then(response => {
        console.log(response.data)
      }).catch(error => {
        console.log(error);
      });
    },
  },
  filters: {
    lowercase: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.toLowerCase()
    }
  },
  created() {
    let self = this;

    //Random promotions
    if (!_.isEmpty(this.top_promotions) && _.isArray(this.top_promotions)) {
      // _.each(this.top_promotions, (promotion) => this.saveMerchant(promotion));
      this.top_promotions = _.sampleSize(this.top_promotions, 4);

    }
  },
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/merchants/MainHomeContent.vue